import React, { useCallback, useState } from 'react'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { RegisterOptions, useController } from 'react-hook-form'
import { Visibility, VisibilityOff } from '@mui/icons-material'

export const InputField = ({
  name,
  title,
  readOnly,
  rules,
  type,
  multiline,
  rows,
  disabled
}: {
  name: string
  title: string
  readOnly?: boolean
  rules?: RegisterOptions
  type?: string
  multiline?: boolean
  rows?: number
  disabled?: boolean
}) => {
  const { field, fieldState } = useController({ name, rules })

  const handleOnBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      if (type !== 'password') {
        const trimmed = event.target.value.trim()
        if (trimmed !== event.target.value) {
          field.onChange(trimmed)
        }
      }
    },
    [field, type]
  )
  const [showPassword, setShowPassword] = useState(false)
  const isPassword = type === 'password'
  const inputType = isPassword && showPassword ? 'text' : type

  return (
    <TextField
      onBlur={handleOnBlur}
      InputProps={{
        readOnly: readOnly,
        endAdornment: isPassword && (
          <InputAdornment position='end'>
            <IconButton
              onClick={() => setShowPassword((prev) => !prev)}
              edge='end'
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              sx={{ mr: 0 }}
            >
              {showPassword ? <VisibilityOff fontSize='small' /> : <Visibility fontSize='small' />}
            </IconButton>
          </InputAdornment>
        )
      }}
      label={title}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      value={field.value}
      onChange={field.onChange}
      multiline={multiline}
      rows={rows || 1}
      type={inputType}
      data-cy={`contactus-form-${field.name}`}
      sx={{ input: { color: readOnly ? '#888' : undefined } }}
      disabled={disabled}
    />
  )
}
